import React from 'react'

const Pagination1 = ({ postsPerPage, totalPosts, paginate}) => {

    // Set number of pages
    const pageNumbers = [];
    for(let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i++) {
        pageNumbers.push(i)
    }

   
  return (
    <nav className='text-center'>
        <ul className='pagination justify-content-center'>
            {pageNumbers.map(number => (
                <li key={number} className='page-item'> 
                    <a onClick={() => paginate(number)} href="#" className='page-link'>
                        {number}
                    </a>
                </li>
            ))}
        </ul>
    </nav>
  )
}

export default Pagination1